import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
import { adminAPI } from '../../utils/api';

const AdminLoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const { error } = useToast();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminAPI.login(form);
      navigate('/admin/dashboard');
    } catch (err) {
      error(err.response?.data?.message || 'Invalid credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1A1A2E', fontFamily: "'Nunito', sans-serif" }}>
      <div style={{ background: 'white', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{ width: '48px', height: '48px', borderRadius: '12px', background: '#FF6B00', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Baloo 2', cursive", fontSize: '20px', fontWeight: 800, color: 'white', margin: '0 auto 12px' }}>G</div>
          <div style={{ fontFamily: "'Baloo 2', cursive", fontSize: '18px', fontWeight: 800, color: '#FF6B00' }}>MyPersonalGuruji</div>
          <div style={{ fontSize: '12px', color: '#64748B', marginTop: '2px' }}>Admin Panel</div>
        </div>

        <h2 style={{ fontSize: '18px', fontWeight: 800, marginBottom: '20px', color: '#1A1A2E' }}>Admin Login</h2>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '14px' }}>
            <label style={{ fontSize: '11px', fontWeight: 800, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.4px', display: 'block', marginBottom: '5px' }}>Email</label>
            <input
              type="email"
              style={{ width: '100%', background: '#F7F8FC', border: '1.5px solid #E2E8F0', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#1A1A2E', outline: 'none' }}
              value={form.email}
              onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
              placeholder="admin@mypersonalguruji.com"
              required
            />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontSize: '11px', fontWeight: 800, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.4px', display: 'block', marginBottom: '5px' }}>Password</label>
            <input
              type="password"
              style={{ width: '100%', background: '#F7F8FC', border: '1.5px solid #E2E8F0', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#1A1A2E', outline: 'none' }}
              value={form.password}
              onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
              placeholder="Your password"
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{ width: '100%', background: '#FF6B00', color: 'white', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: 800, cursor: 'pointer', opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Logging in...' : 'Login to Admin Panel'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '16px', fontSize: '12px', color: '#64748B' }}>
          Student login? <span style={{ color: '#FF6B00', fontWeight: 800, cursor: 'pointer' }} onClick={() => navigate('/')}>Go here →</span>
        </p>
      </div>
    </div>
  );
};

export default AdminLoginPage;
